import axios from 'axios';

const API = process.env.VUE_APP_API_URL || 'http://127.0.0.1:5000';

// Normalize backend reading objects to the shape expected by the UI
const normalizeStory = (raw) => {
  if (!raw || typeof raw !== 'object') return {};
  const levelNumber = (() => {
    if (typeof raw.level === 'number') return raw.level;
    if (typeof raw.readingLevel === 'string') {
      const n = parseInt(raw.readingLevel.replace(/[^0-9]/g, ''), 10);
      return Number.isFinite(n) ? n : undefined;
    }
    return undefined;
  })();
  const contentArray = Array.isArray(raw.content) ? raw.content : [];
  return {
    id: raw.id,
    title: raw.title,
    summary: raw.summary || '',
    author: raw.author || 'Unknown',
    // Backend provides numeric level; UI uses string like "Level 2"
    level: levelNumber,
    readingLevel: raw.readingLevel || (levelNumber ? `Level ${levelNumber}` : undefined),
    // Pages may come from page_cnt, pages, or content length
    pages: Number.isFinite(raw.pages) ? raw.pages : (Number.isFinite(raw.page_cnt) ? raw.page_cnt : (Array.isArray(raw.content) ? raw.content.length : 0)),
    page_cnt: Number.isFinite(raw.page_cnt) ? raw.page_cnt : (Number.isFinite(raw.pages) ? raw.pages : (Array.isArray(raw.content) ? raw.content.length : 0)),
    rating: raw.rating || 4.8,
    thumbnail: raw.thumbnail || '📖',
    category: raw.category || '',
    url: raw.url || '',
    content: contentArray,
    // Preserve any other fields
    ...('recentlyRead' in raw ? { recentlyRead: !!raw.recentlyRead } : {}),
    ...('isFavorite' in raw ? { isFavorite: !!raw.isFavorite } : {}),
  };
};

const normalizeList = (arr) => Array.isArray(arr) ? arr.map(normalizeStory) : [];

export const getSuggestions = async (userId) => {
  const res = await axios.get(`${API}/api/readings/${userId}`);
  return normalizeList(res.data);
};

export const getMoreStories = async (userId, loadedIds = []) => {
  const res = await axios.post(`${API}/api/readings/more/${userId}`, { loaded: loadedIds });
  return normalizeList(res.data);
};

export const getByLevel = async (userId, level, loadedIds = []) => {
  const res = await axios.post(`${API}/api/readings/${userId}/${level}`, { loaded: loadedIds });
  return normalizeList(res.data);
};

export const getFavourites = async (userId, loadedIds = []) => {
  const res = await axios.post(`${API}/api/readings/${userId}/favourite`, { loaded: loadedIds });
  return normalizeList(res.data);
};

export const getRecents = async (userId, loadedIds = []) => {
  const res = await axios.post(`${API}/api/readings/${userId}/recents`, { loaded: loadedIds });
  return normalizeList(res.data);
};

export const getByCategory = async (userId, category) => {
  const res = await axios.post(`${API}/api/readings/${userId}/category`, { category });
  return normalizeList(res.data);
};

export const searchReadings = async (userId, srch_str) => {
  const res = await axios.post(`${API}/api/readings/${userId}/search`, { srch_str });
  return normalizeList(res.data);
};

export const getBook = async (userId, bookId) => {
  const res = await axios.get(`${API}/api/reading/${userId}/${bookId}`);
  const data = res.data || {};
  // Ensure content is an array of page objects with a text field
  let content = Array.isArray(data.content) ? data.content : [];
  if (Array.isArray(content) && content.length > 0) {
    content = content.map((page, idx) => {
      // If page is a string, wrap it
      if (typeof page === 'string') {
        return { pageNumber: idx + 1, title: `Page ${idx + 1}`, text: page, illustration: '' };
      }
      // If object but missing text, synthesize from available fields
      const text = typeof page.text === 'string' ? page.text : (typeof page.body === 'string' ? page.body : '');
      return {
        pageNumber: page.pageNumber || idx + 1,
        title: page.title || `Page ${idx + 1}`,
        text,
        illustration: page.illustration || '',
        ...page,
      };
    });
  }
  return {
    id: data.id,
    content,
    pages_read: Number.isFinite(data.pages_read) ? data.pages_read : 0,
  };
};

export const updateProgress = async (userId, bookId, payload) => {
  const res = await axios.put(`${API}/api/reading/${userId}/${bookId}/progress_update`, payload);
  return res.data;
};

export default {
  getSuggestions,
  getMoreStories,
  getByLevel,
  getFavourites,
  getRecents,
  getByCategory,
  searchReadings,
  getBook,
  updateProgress,
};


